import { motion } from 'framer-motion'
import { LucideIcon } from 'lucide-react'

interface StatCardProps {
  title: string
  value: string | number
  subtitle?: string
  icon: LucideIcon
  delay?: number
}

export function StatCard({ title, value, subtitle, icon: Icon, delay = 0 }: StatCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.3 }}
      className="stat-gradient rounded-lg sm:rounded-xl p-3 sm:p-[22px] shadow-sm border border-border"
    >
      {/* Header with icon and label */}
      <div className="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-4">
        <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-card flex items-center justify-center">
          <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-foreground" />
        </div>
        <span className="text-[11px] sm:text-[13px] font-medium text-text-secondary leading-tight">{title}</span>
      </div>

      {/* Value and subtitle */}
      <div className="flex flex-col gap-0.5 sm:gap-1">
        <motion.span
          className="text-xl sm:text-2xl lg:text-4xl font-bold text-text-dark tracking-tight leading-none"
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: delay + 0.1, type: 'spring' }}
        >
          {value}
        </motion.span>
        {subtitle && (
          <span className="text-[11px] sm:text-[13px] text-text-muted">
            {subtitle}
          </span>
        )}
      </div>
    </motion.div>
  )
}
